export default __webpack_public_path__ + "static/img_case_02-52b17290f8470a29272797d78647c78a.webp";